"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryString = exports.QueryStringConversionFlags = void 0;
/**
 * Configures flags for how query string conversion should be performed.
 */
var QueryStringConversionFlags;
(function (QueryStringConversionFlags) {
    QueryStringConversionFlags[QueryStringConversionFlags["None"] = 0] = "None";
    /**
     * Converted query string will contain a leading question mark IF the query string is not empty.
     */
    QueryStringConversionFlags[QueryStringConversionFlags["WithLeadingQuestionMark"] = 1] = "WithLeadingQuestionMark";
    /**
     * Empty parameters will be kept in the querystring (e.g. "?foo=&bar=123", "foo" has no value here but it is kept)
     */
    QueryStringConversionFlags[QueryStringConversionFlags["KeepEmptyParameters"] = 2] = "KeepEmptyParameters";
})(QueryStringConversionFlags = exports.QueryStringConversionFlags || (exports.QueryStringConversionFlags = {}));
class QueryString {
    static toQueryString(kv, flags = QueryStringConversionFlags.WithLeadingQuestionMark) {
        let qsArr = [];
        for (const key in kv) {
            const value = kv[key];
            if (value || (flags & QueryStringConversionFlags.KeepEmptyParameters))
                qsArr.push(key + "=" + encodeURIComponent(value));
        }
        let qs = qsArr.join("&");
        if (qs.length > 0 && (flags & QueryStringConversionFlags.WithLeadingQuestionMark))
            return "?" + qs;
        return qs;
    }
}
exports.QueryString = QueryString;
